import { Record } from 'immutable';
import { Base } from './base';

class Image extends Base(Record({
    id: null,
    owner_id: null,
    owner_type: 'vendors',
    delete_token: null,
    label: null,
    url: null,
  })) {
    $create(id) {
      return this.api.post({
        resource: 'images'
      }, this.api.payload('images', id ? this.set('owner_id', id) : this))
      .then(res => this.dispatch(this.actions.receiveEntity(res.data)))
    }

    $get(id, ownerType) {
      if (this.owner_id) id = this.owner_id;
      if(!ownerType) ownerType = 'vendors';

      if (!id) return Promise.resolve(null);

      return this.api.get({
        resource: 'images?filter[owner_id]=' + id + '&filter[owner_type]=' + ownerType + ',users'
      })
      .then(res => this.dispatch(this.actions.receiveEntities(res.data, 'images')));
    }

    $delete(id) {
      if (!id) id = this.id;

      if (!id || (!this.url || this.url === '')) return Promise.resolve('No op');

      return this.api.delete({
        id: id,
        resource: 'images'
      })
      .then(res => this.dispatch(this.actions.clearEntity(this, 'images')));
    }

    withTransformations(transformations) {
      let url;

      if (transformations) {
        let urlParts = this.url.split('/');
        let index = urlParts.indexOf('upload');
        let start = urlParts.slice(0, index + 1);
        let end = urlParts.slice(index + 1);
        start.push(transformations);
        url = start.concat(end).join('/');
      }

      return url || this.url;
    }
  }

export default Image;



// WEBPACK FOOTER //
// ./src/records/image.js